import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import YouTubeEmbed from './YouTubeEmbed';

interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  title: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ open, onClose, videoUrl, title }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
        },
      }}
    >
      <DialogContent
        sx={{
          position: 'relative',
          padding: 0,
          backgroundColor: 'transparent',
          '&:first-of-type': {
            paddingTop: 0,
          },
        }}
      >
        {/* Close button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: -50,
            right: -10,
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Video container */}
        <Box
          sx={{
            width: '100%',
            backgroundColor: 'black',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <YouTubeEmbed 
            videoUrl={videoUrl} 
            title={title}
            maxWidth="100%"
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal; 